import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';
import { getJson, getErrMsg } from '../service/serviceUtil';

import ContextualMessage from '../components/contextualMessage';
import InputPassword from '../components/inputPassword';
import UserDisplay from '../components/userDisplay';

import './demandeMotPasse.css';

class DemandeMotPasse extends Component {
    constructor(props) {
        super(props);

        this.state = {
            password: "",
            showErrorNoEmail: false,
            error: null,
            typeMsg: null, 
            txtMsg: null, 
            errorApi: false
        };
    }

    get labels() {
        return chainesLocales['DemandeMotPasse'][this.props.lang];
    }

    render() {
        return (
            <form className="DemandeMotPasse text-left" onSubmit={this.onSubmit.bind(this)}>
                <h1>{this.labels.title}</h1>
                <UserDisplay user={this.props.user.username} lang={this.props.lang} />
                {
                    this.state.showErrorNoEmail ? <ContextualMessage type="warning" content={this.labels.textResetPwd} /> : null
                }
                {
                    this.state.txtMsg ? <ContextualMessage type={this.state.typeMsg} showIcon={false} content={this.state.txtMsg} /> : null
                }
                {
                    this.state.error ? <ContextualMessage type="error" content={getErrMsg(this.state.error, this.props.lang)} /> : null
                }
                {
                    this.state.errorApi ? <ContextualMessage type="error" showIcon={false} content={chainesLocales['ErrApi'][this.props.lang].msg} /> : null
                }
                <div className="form-group">
                    <label htmlFor="password" className={this.state.error && this.state.error.code === 4 ? 'is-invalid' : ''} style={{ fontSize: "1.1rem" }}>{this.labels.labelPwd}</label>
                    <InputPassword focus={true} id='password' isInvalid={this.state.error && this.state.error.code === 4 ? true : false} value={this.state.password} onChange={this.onChange.bind(this)} lang={this.props.lang} />
                    <a href="#oublie" role="button" onClick={this.onForgetPasswordClick.bind(this)} className="mdp-oublie text-muted small">{this.labels.labelResetPwd}</a>
                </div>
                <div>
                    <button className="btn btn-primary" type="submit" disabled={this.state.password.length === 0}><span className="label">{this.labels.button}</span><span className="spinner"></span></button>
                </div>
            </form>
        )
    }

    onForgetPasswordClick(e) {
        e.preventDefault();

        if (this.props.user.hasEmail) {
            this.props.onPageSuccess({ logon: { newPage: "sendRecoveryCode" }});
        } else {
            this.setState({ showErrorNoEmail: true });
        }
    }

    onClickNousJoindre(e) {
        e.preventDefault();

        this.props.showModal("nous-joindre");
    }

    onChange(e) {
        this.setState({ password: e.target.value });
    }

    onSubmit(e) {
        e.preventDefault();

        if (document.querySelector) {
            document.querySelector('button[type="submit"]').disabled = true;
            if (document.body.classList) document.querySelector('button[type="submit"]').classList.add('loading');
        }

        let formData = new FormData();
        formData.append("password", this.state.password.trim());

        let defaultParams = {
            lang: this.props.lang,
            suffixe: this.props.suffixe
        };

        let fetchOptions = {
            method: "POST",
            credentials: "same-origin",
            body: formData
        };

        getJson('logon', defaultParams, fetchOptions).then(logonData => {
            if (logonData.passwordValid === true) {
                this.props.onPageSuccess({ logon: logonData });
            } else {
                this.setState({ error: logonData.error, typeMsg: logonData.type, txtMsg: logonData.message, errorApi: ((!logonData.error && !logonData.message) ? true : false) }, () => {
                    if (document.querySelector) {
                        document.querySelector('button[type="submit"]').disabled = false;
                        if (document.body.classList) document.querySelector('button[type="submit"]').classList.remove('loading');
                    }
                });
            }
        }).catch(err => {
            console.error("Erreur API mot de passe: " + err);

            this.setState({ errorApi: true, error: null, typeMsg: null, txtMsg: null }, () => {
                if (document.querySelector) {
                    document.querySelector('button[type="submit"]').disabled = false;
                    if (document.body.classList) document.querySelector('button[type="submit"]').classList.remove('loading');
                }
            });
        });
    }
}

DemandeMotPasse.propTypes = {
    user: PropTypes.object.isRequired,
    onPageSuccess: PropTypes.func.isRequired/*,
    onOublieMotPasse: PropTypes.func.isRequired*/
};

export default DemandeMotPasse;